import { render, staticRenderFns } from "./FileIssue.vue?vue&type=template&id=2318716a&scoped=true"
import script from "./FileIssue.vue?vue&type=script&lang=js"
export * from "./FileIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318716a",
  null
  
)

export default component.exports